import { c as _c } from "react/compiler-runtime";
import FunnelEmailCreate from 'modules/funnels/funnel/components/email-tab/funnel-email-create';
import FunnelEmailTable from 'modules/funnels/funnel/components/email-tab/funnel-email-table';
import { useFunnelEmails } from 'modules/funnels/funnel/components/email-tab/hooks/use-funnel-emails';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
interface FunnelEmailTabProps {
  funnelStepId?: FunnelStepId;
}
function EmailTab(t0) {
  const $ = _c(19);
  const {
    funnelStepId
  } = t0;
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  let t1;
  if ($[0] !== funnelStepId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      limit,
      pagination,
      funnelStepId
    };
    $[0] = funnelStepId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: emails,
    mutate: mutateEmails
  } = useFunnelEmails(t1);
  let t2;
  if ($[4] !== emails || $[5] !== funnelStepId || $[6] !== limit || $[7] !== mutateEmails || $[8] !== pagination || $[9] !== setLimit || $[10] !== setPagination) {
    t2 = <FunnelEmailTable emails={emails} funnelStepId={funnelStepId} limit={limit} setLimit={setLimit} setPagination={setPagination} pagination={pagination} mutateEmails={mutateEmails} />;
    $[4] = emails;
    $[5] = funnelStepId;
    $[6] = limit;
    $[7] = mutateEmails;
    $[8] = pagination;
    $[9] = setLimit;
    $[10] = setPagination;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== emails || $[13] !== funnelStepId || $[14] !== setPagination) {
    t3 = <FunnelEmailCreate funnelStepId={funnelStepId} emails={emails} setPagination={setPagination} />;
    $[12] = emails;
    $[13] = funnelStepId;
    $[14] = setPagination;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t2 || $[17] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
export default EmailTab;